export default __webpack_public_path__ + "static/media/diego_alonso.362495ec.jpg";